<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container job-cust-select-modal">
          <div class="modal-header">
            <slot name="header">
              Customer Selection
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <form class="col-12" @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-1">
                    <label for="round">Round:</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="round"
                      ref="schedule_round_name"
                      name="round"
                      placeholder="round"
                      v-model="round_name"
                    />
                  </div>
                  <div class="col-1">
                    <label for="week">Week:</label>
                  </div>
                  <div class="col-4">
                    <select
                      class="form-control"
                      ref="schedule_round_week"
                      v-model="selected_week"
                    >
                      <option v-if="editable" value="-1"></option>
                      <option
                        v-for="index in num_weeks"
                        :value="index - 1"
                        v-bind:key="id + 'week' + index"
                        >Week {{ index }}</option
                      >
                    </select>
                  </div>
                  <div
                    v-if="submitted && errors.has('round')"
                    class="col-12 invalid-feedback"
                  >
                    {{ errors.first("round") }}
                  </div>
                  <div
                    v-if="submitted && errors.has('week')"
                    class="col-12 invalid-feedback"
                  >
                    {{ errors.first("week") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <label for="area">Area:</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="area"
                      ref="schedule_round_area"
                      name="area"
                      placeholder="area"
                      v-model="round_area"
                    />
                  </div>
                  <div class="col-1">
                    <label for="day">Day:</label>
                  </div>
                  <div class="col-4">
                    <select
                      class="form-control"
                      ref="schedule_round_day"
                      v-model="selected_day"
                    >
                      <option v-if="editable" value="-1"></option>
                      <option v-if="schedule_group.days > 0" value="0"
                        >Monday</option
                      >
                      <option v-if="schedule_group.days > 1" value="1"
                        >Tuesday</option
                      >
                      <option v-if="schedule_group.days > 2" value="2"
                        >Wednesday</option
                      >
                      <option v-if="schedule_group.days > 3" value="3"
                        >Thursday</option
                      >
                      <option v-if="schedule_group.days > 4" value="4"
                        >Friday</option
                      >
                      <option v-if="schedule_group.days > 5" value="5"
                        >Saturday</option
                      >
                      <option v-if="schedule_group.days > 6" value="6"
                        >Sunday</option
                      >
                    </select>
                  </div>
                  <div
                    v-if="submitted && errors.has('area')"
                    class="col-12 invalid-feedback"
                  >
                    {{ errors.first("area") }}
                  </div>
                  <div
                    v-if="submitted && errors.has('day')"
                    class="col-12 invalid-feedback"
                  >
                    {{ errors.first("day") }}
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="btn-group btn-group-toggle ml-15">
                    <label
                      class="btn btn-plt btn-plt-tab"
                      :class="tab === 1 ? 'selected active' : ''"
                    >
                      <input
                        class="btn-group-toggle"
                        type="radio"
                        name="options"
                        id="option1"
                        :value="1"
                        autocomplete="off"
                        v-model.number="tab"
                      />
                      Customer
                    </label>
                    <label
                      class="btn btn-plt btn-plt-tab"
                      :class="tab === 2 ? 'selected active' : ''"
                    >
                      <input
                        type="radio"
                        name="options"
                        id="option2"
                        :value="2"
                        autocomplete="off"
                        v-model.number="tab"
                      />
                      Personnel
                    </label>
                    <label
                      class="btn btn-plt btn-plt-tab"
                      :class="tab === 3 ? 'selected active' : ''"
                    >
                      <input
                        type="radio"
                        name="options"
                        id="option3"
                        :value="3"
                        autocomplete="off"
                        v-model.number="tab"
                      />
                      Vehicle
                    </label>
                    <label
                      class="btn btn-plt btn-plt-tab"
                      :class="tab === 4 ? 'selected active' : ''"
                    >
                      <input
                        type="radio"
                        name="options"
                        id="option4"
                        :value="4"
                        autocomplete="off"
                        v-model.number="tab"
                      />
                      Changes
                    </label>
                  </div>
                </div>
                <div class="row" v-show="tab == 1">
                  <div class="col-2"></div>
                  <div class="col-5">Available:</div>
                  <div class="col-5">Assigned:</div>
                </div>
                <div class="row" v-show="tab == 2">
                  <div class="col-2"></div>
                  <div class="col-5">Available:</div>
                  <div class="col-5">Assigned:</div>
                </div>
                <div class="row scroll-500" v-show="tab == 1">
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="avail_customers"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group
                        type="transition"
                        :name="'flip-list'"
                        class="d-block h-100"
                      >
                        <li
                          class="cust-select-item"
                          v-for="element in avail_customers"
                          :key="id + 'custa' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.description }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="schedule_round.round.jobs"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group name="no" class="d-block h-100">
                        <li
                          class="cust-select-item"
                          v-for="element in schedule_round.round.jobs"
                          :key="id + 'custs' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.description }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
                <div class="row scroll-500" v-show="tab == 2">
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="personnel_list"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group
                        type="transition"
                        :name="'personnel-list'"
                        class="d-block h-100"
                      >
                        <li
                          class="pers-select-item"
                          v-for="element in personnel_list"
                          :key="id + 'pera' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.name }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="selected_personnel_list"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group name="no" class="d-block h-100">
                        <li
                          class="pers-select-item"
                          v-for="element in selected_personnel_list"
                          :key="id + 'pers' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.name }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
                <div class="row scroll-500" v-show="tab == 3">
                  <div class="col-1">
                    <label for="vehicle">Vehicle:</label>
                  </div>
                  <div class="col-4">
                    <select
                      class="form-control"
                      ref="schedule_round_vehicle"
                      v-model="selected_vehicle"
                    >
                      <option value="-1"></option>
                      <option
                        v-for="item in vehicles"
                        :value="item.id"
                        v-bind:key="id + 'veh' + item.id"
                        >{{ item.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="row scroll-500" v-show="tab == 4">
                  <div
                    v-if="round_changes && !round_changes.length"
                    class="col"
                  >
                    No Changes to display
                  </div>
                  <div v-else class="col">
                    <div class="row">
                      <div class="col-12">Description</div>
                    </div>
                    <div
                      v-for="change in round_changes"
                      v-bind:key="id + 'exc' + change.id"
                      class="row"
                    >
                      <div class="col-12">
                        Round changed from
                        {{ moment(change.from_date).format("DD/MM/yyyy") }} to
                        {{ moment(change.to_date).format("DD/MM/yyyy") }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                v-if="copy_enabled && editable"
                class="btn btn-plt"
                @click="$emit('add-change')"
              >
                Add Change
              </button>
              <button
                v-if="copy_enabled && editable"
                class="btn btn-plt"
                @click="$emit('copy')"
              >
                Copy
              </button>
              <button
                v-if="copy_enabled && editable"
                class="btn btn-plt"
                @click="$emit('move')"
              >
                Move
              </button>
              <button v-if="editable" class="btn btn-plt" @click="_delete">
                Delete
              </button>
              <button v-if="editable" class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="_close">
                Close without save
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  name: "CustomerSelection",
  props: {
    schedule_index: {
      type: Number,
      default: -1,
    },
    schedule_round: {
      type: Object,
      required: true,
    },
    week_index: {
      type: Number,
      default: -1,
    },
    day_index: {
      type: Number,
      default: -1,
    },
    copy_enabled: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    submitted: false,
    avail_customers: [],
    personnel_list: [],
    selected_personnel_list: [],
    selected_week: -1,
    selected_day: -1,
    selected_vehicle: -1,
    round_name: "",
    round_area: "",
    num_weeks: 0,
    tab: 1,
    id: -1,
    round_changes: {},
  }),
  computed: {
    ...mapState("schedule", ["schedules", "schedule_group", "available_jobs"]),
    ...mapState("vehicles", ["vehicles"]),
    ...mapState("personnels", ["personnels"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  mounted: function() {
    this.id = this._uid;
    this.$nextTick(function() {
      this.avail_customers = this.available_jobs.slice();
      this.selected_week = this.schedule_round.week_index;
      this.selected_day = this.schedule_round.day_index;
      this.round_name = this.schedule_round.round.name;
      this.round_area = this.schedule_round.round.area;
      this.selected_vehicle = this.schedule_round.vehicle_id;
      this.selected_personnel_list = this.schedule_round.personnels;
      this.round_changes = this.schedule_round.changes;
      if (this.schedule_index >= 0) {
        this.num_weeks = Number(this.schedules[this.schedule_index].duration);
      } else {
        this.num_weeks = this.schedule_group.duration;
      }

      if (!this.selected_personnel_list) {
        this.personnel_list = this.personnels.slice();
      } else {
        // remove all the personnel in the selected list from the available personnels
        var vm = this;
        this.personnel_list = this.personnels.filter(function(value) {
          var index = vm.selected_personnel_list.findIndex(
            v => v.id == value.id,
          );
          return index < 0;
        });
      }
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // submit data
        }
      });
    },
    ...mapActions("schedule", ["loadAvailableJobs", "moveScheduleRoundFrom"]),
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    getName() {
      return this.schedule_round.round.name;
    },
    getArea() {
      return this.schedule_round.round.area;
    },
    getWeek() {
      if (this.week_index >= 0) {
        return this.week_index + 1;
      } else {
        return "";
      }
    },
    _delete() {
      this.$emit("delete");
    },
    _save() {
      if (this.selected_week < 0) {
        alert("please select a week");
        return;
      } else if (this.selected_day < 0) {
        alert("please select a day");
        return;
      } else if (!this.$refs.schedule_round_name.value) {
        alert("please enter a round name");
        return;
      } else if (!this.$refs.schedule_round_area.value) {
        alert("please enter an area");
        return;
      } else if (this.selected_vehicle < 1) {
        alert("please select a vehicle");
        return;
      } else if (this.selected_personnel_list.length < 1) {
        alert("please select a personnel");
        return;
      }
      if (this.schedule_round) {
        this.schedule_round.round.name = this.$refs.schedule_round_name.value;
        this.schedule_round.round.area = this.$refs.schedule_round_area.value;
        this.schedule_round.week_index = this.selected_week;
        this.schedule_round.day_index = this.selected_day;
        this.schedule_round.vehicle_id = this.selected_vehicle;
        if (
          !this.schedule_round.vehicle ||
          this.schedule_round.vehicle.id != this.schedule_round.vehicle_id
        ) {
          var vehicle_index = this.vehicles.findIndex(
            v => v.id == this.schedule_round.vehicle_id,
          );
          this.schedule_round.vehicle = this.vehicles[vehicle_index];
        }
        this.schedule_round.personnels = this.selected_personnel_list;
        this.loadAvailableJobs(this.avail_customers);
        if (
          this.week_index != this.schedule_round.week_index ||
          this.day_index != this.schedule_round.day_index
        ) {
          this.moveScheduleRoundFrom({
            schedule_index: this.schedule_index,
            schedule_round: this.schedule_round,
            from_week_index: this.week_index,
            from_day_index: this.day_index,
          });
        }
        this.$emit("save");
      }
    },
    _close() {
      if (this.schedule_round && !this.schedule_round.active) {
        this.schedule_round.active = true;
      }
      this.$emit("close");
    },
    _showTab(index) {
      this.tab = index;
    },
    moment(arg) {
      return moment(arg);
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    available_jobs(newValue) {
      this.avail_customers = newValue.slice();
    },
  },
  components: {
    draggable,
  },
};
</script>
